import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import { fetchError } from '../actions/Common';
import { fetchCompanyNameSuccess } from '../actions/BaseConfig';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError } from '../../helper/Alert';
import FaraGostarHttp from '../../api/FaraGostarHttp';
import { AxiosResponse } from 'axios';

const getCompanyName = async () => {
  const http = await FaraGostarHttp();
  return await http.get('basicConfig/GetCompanyName');
};

function* fetchCompanyNameRequest(): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedCompanyName = yield call(getCompanyName);
    yield put(fetchCompanyNameSuccess(fetchedCompanyName.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchCompanyName() {
  yield takeEvery(ActionTypes.GET_Company_Name, fetchCompanyNameRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchCompanyName)]);
}
